export function usePercentages(numbers: number[]) {
	const sum = numbers.reduce((c, n) => c + n);

	const flooredNumbersAndRemainders = numbers.map((n) => {
		const percentage = n === 0 ? 0 : (n / sum) * 100;
		const flooredPercentage = Math.floor(percentage);
		return {
			flooredPercentage,
			remainder: percentage - flooredPercentage,
		};
	});

	while (
		sum !== 0 &&
		![100, 99].includes(
			flooredNumbersAndRemainders.reduce((c, n) => c + n.flooredPercentage, 0)
		)
	) {
		let biggestRemainder = flooredNumbersAndRemainders[0];
		flooredNumbersAndRemainders.forEach((v) => {
			if (v.remainder > biggestRemainder.remainder) {
				biggestRemainder = v;
			}
		});
		biggestRemainder.flooredPercentage = biggestRemainder.flooredPercentage + 1;
		biggestRemainder.remainder = 0;
	}
	const percentages = {
		percentages: flooredNumbersAndRemainders.map((r) => r.flooredPercentage),
		sum,
	};

	return percentages;
}
